import { render } from "./App.vue?vue&type=template&id=8f0ff206&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=8f0ff206&lang=scss"
import "./App.vue?vue&type=style&index=1&id=8f0ff206&lang=css"

import exportComponent from "D:\\Users\\temari\\WebstormProjects\\iidx_viewer\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__